import { apiBase } from "./base";

export const apiNmck = {
	client: apiBase.get_client(),
	url: "/nmck/",

	getBooks() {
		return this.client.get(this.url + "books/", apiBase.get_headers());
	},

	createItem(body) {
		return this.client.post(this.url + "item/", body, apiBase.get_headers());
	},

	getItem({ itemId }) {
		return this.client.get(this.url + "item/" + itemId + "/", apiBase.get_headers());
	},

	editItem({ itemId, body }) {
		return this.client.patch(this.url + "item/" + itemId + "/", body, apiBase.get_headers());
	},

	deleteItem({ itemId }) {
		return this.client.delete(this.url + "item/" + itemId + "/", apiBase.get_headers());
	},

	printItem({ nmckId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "printer/" + nmckId + "/short/", headers);
	},

	getCosts({ nmckId }) {
		return this.client.get(this.url + "tree/" + nmckId + "/", apiBase.get_headers());
	},

	createReason(body) {
		return this.client.post(this.url + "item_reasons/", body, apiBase.get_headers());
	},

	editReason(body) {
		return this.client.patch(this.url + "item_reasons/", body, apiBase.get_headers());
	},

	deleteReason({ reasonId }) {
		return this.client.delete(this.url + "item_reasons/" + reasonId + "/", apiBase.get_headers());
	},

	createCalc(body) {
		return this.client.post(this.url + "item_calcs/", body, apiBase.get_headers());
	},

	editCalc(body) {
		return this.client.patch(this.url + "item_calcs/", body, apiBase.get_headers());
	},

	deleteCalc({ calcId }) {
		return this.client.delete(this.url + "item_calcs/" + calcId + "/", apiBase.get_headers());
	},

	editEstimates(body) {
		return this.client.post(this.url + "user_changes/", body, apiBase.get_headers());
	},

	editReserv(body) {
		return this.client.post(this.url + "item_reserv/", body, apiBase.get_headers());
	},

	createGroup(body) {
		return this.client.post(this.url + "groups/", body, apiBase.get_headers());
	},

	editGroup(body) {
		return this.client.patch(this.url + "groups/", body, apiBase.get_headers());
	},

	deleteGroup({ groupId }) {
		return this.client.delete(this.url + "groups/" + groupId + "/", apiBase.get_headers());
	},

	addToGroup(body) {
		return this.client.post(this.url + "group_links/", body, apiBase.get_headers());
	},

	deleteFromGroup({ groupId, nmckId }) {
		return this.client.delete(this.url + "group_links/" + groupId + "/" + nmckId + "/", apiBase.get_headers());
	},

	exportXmlItem({ nmckId, mode }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "xml/output/" + nmckId + "/with_links/" + mode + "/", headers);
	},
};
